/**
 * localStorage key for the conversion data
 */
export const STORAGE_KEY = 'adConversionData';
/**
 * The lifetime of a single conversion item in milliseconds
 */
export const STORAGE_ITEM_LIFETIME = 86_400_000; // 1 day
//# sourceMappingURL=consts.js.map